import WordCloudPreview from './WordCloudPreview'
export default WordCloudPreview



// WEBPACK FOOTER //
// ./src/components/WorldCloudPreview/index.js